import { getAssetHistoryByUserId, getAssetRequests, cancelAssetRequest } from '../../api/assetsApi';
import { showRequestFailedToast } from './../../service/toastService';

export const LOANED = 'LOANED';
export const RETURNED = 'RETURNED';
export const REQUESTS = 'REQUESTS';
export const FETCH_ASSET_HISTORY = 'FETCH_ASSET_HISTORY';
export const FETCH_ASSET_HISTORY_SUCCESS = 'FETCH_ASSET_HISTORY_SUCCESS';
export const FETCH_ASSET_REQUESTS = 'FETCH_ASSET_REQUESTS';
export const FETCH_ASSET_REQUESTS_SUCCESS = 'FETCH_ASSET_REQUESTS_SUCCESS';
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';

export function fetchAssetHistory(userId, skip, take, historyType) {
  return async function (dispatch) {
    dispatch({ type: FETCH_ASSET_HISTORY });
    try {
      const response = await getAssetHistoryByUserId(userId, { skip, take, historyType });
      return dispatch({
        type: FETCH_ASSET_HISTORY_SUCCESS,
        assetHistory: response.data.data,
        historyType,
        skip,
        take,
        totalCount: response.data.totalCount,
      });
    } catch (error) {
      showRequestFailedToast();
    }
  };
}

export function fetchAssetRequests(userId, skip, take, filters = {}) {
  return async function (dispatch) {
    dispatch({ type: FETCH_ASSET_REQUESTS });
    try {
      const skipParam = (skip || 0) * take;
      const params = {
        skip: skipParam,
        take,
        ...(filters.status !== undefined && filters.status !== '' && { status: parseInt(filters.status) }),
        ...(filters.assetCategoryId && filters.assetCategoryId !== '' && { assetCategoryId: filters.assetCategoryId }),
      };
      const response = await getAssetRequests(userId, params);
      return dispatch({
        type: FETCH_ASSET_REQUESTS_SUCCESS,
        assetRequests: response.data.data,
        skip,
        take,
        totalCount: response.data.totalCount,
      });
    } catch (error) {
      showRequestFailedToast();
    }
  };
}

// The cancel function also includes the filters so we keep the current filter state when refreshing the list after cancelling a request.
export function _cancelAssetRequest(userId, assetRequestId, currentPageIndex, take, filters = {}) {
  return async function (dispatch) {
    try {
      await cancelAssetRequest(assetRequestId);
      const skipParam = (currentPageIndex || 0) * take;
      const params = {
        skip: skipParam,
        take,
        ...(filters.status !== undefined && filters.status !== '' && { status: parseInt(filters.status) }),
        ...(filters.assetCategoryId && filters.assetCategoryId !== '' && { assetCategoryId: filters.assetCategoryId }),
      };
      const response = await getAssetRequests(userId, params);
      return dispatch({
        type: FETCH_ASSET_REQUESTS_SUCCESS,
        assetRequests: response.data.data,
        skip: currentPageIndex,
        take,
        totalCount: response.data.totalCount,
      });
    } catch (error) {
      showRequestFailedToast();
    }
  };
}

export function setSelectedTab(selectedTab) {
  return { type: SET_SELECTED_TAB, selectedTab };
}
